import * as api from './../../http'

export const ActionSetUtils = async ({ commit }) => {
  const utils = await api.http.get('dash/utils').then((response) => response.body)
  commit('SET_utils', utils)
}
export const ActionSetStates = async ({ commit }) => {
  const states = await api.http.get('dash/utils/states').then((response) => response.body)
  commit('SET_states', states)
}

export const ActionSetEmployeesDepartments = async ({ commit }) => {
  const departments = await api.http
    .get('dash/utils/employee_departments')
    .then((response) => response.body)
  commit('SET_employeesDepartments', departments)
}

export const ActionSetEmployeesFunctions = async ({ commit }) => {
  const employeeFunction = await api.http
    .get('dash/utils/employee_funcions')
    .then((response) => response.body)
  commit('SET_employeesFunctions', employeeFunction)
}

export const ActionEmployeesRoles = async ({ commit }) => {
  const roles = await api.http.get('dash/utils/employee_roles').then((response) => response.body)
  commit('SET_employeesRoles', roles)
}

export const ActionMaritalStatus = async ({ commit }) => {
  const maritalStatus = await api.http
    .get('dash/utils/marital_status')
    .then((response) => response.body)
  commit('SET_maritalStatus', maritalStatus)
}

export const ActionGenders = async ({ commit }) => {
  const genders = await api.http.get('dash/utils/genders').then((response) => response.body)
  commit('SET_genders', genders)
}

export const ActionSetMonthOfTheYear = async ({ commit }) => {
  const months = await api.http
    .get('dash/utils/months_of_the_year')
    .then((response) => response.body)
  commit('SET_monthsOfTheYear', months)
}

export const ActionStorePaycheckEmployee = async ({ commit }, data) => {
  const paycheck = await api.http.post('employees/paycheck', data)
  commit('SET_employeePaycheck', paycheck.body)
}

export const ActionGetPaycheckEmployee = async ({ commit }, employee_id) => {
  const paycheck = await api.http
    .get(`employees/paycheck/${employee_id}`)
    .then((response) => response.body)
  commit('SET_employeePaycheck', paycheck)
}

export const ActionSetPaycheckEmployee = async ({ commit }) => {
  const paycheck = await api.http
    .get('dash/utils/employee_paycheck')
    .then((response) => response.body)
  commit('SET_employeePaycheck', paycheck)
}
